export default __webpack_public_path__ + "static/media/iron.28527492.png";